"use strict"

import { HttpService } from "../http/http.service"
import FirebaseService from "../firebase/firebase.service"

export default class MediaService {
  /**
   * @param {HttpService} HttpService
   * @param {FirebaseService} FirebaseService
   */
  constructor(environment, HttpService, FirebaseService) {
    "ngInject"

    this._environment = environment
    /** @type {HttpService} */
    this._httpService = HttpService
    /** @type {FirebaseService} */
    this._firebaseService = FirebaseService
  }

  /**
   * @param file {Blob}
   * @param intent {string}
   * @param elementListId {string}
   * @returns {Promise.<{mediaLink: string, newElementId: string}>}
   */
  create(file, intent, elementListId) {
    let newElementId = this._firebaseService.newId()
    let formData = new FormData()
    formData.append("file", file)
    formData.append("intent", intent)
    formData.append("element_list_id", elementListId)

    return this._httpService
      .authPost(
        `${this._environment.serverUrlBase}/v1/media/${newElementId}`,
        formData,
        {
          headers: {
            "Content-Type": undefined,
          },
          transformRequest: angular.identify,
        },
      )
      .then((data) => {
        return {
          mediaLink: data.media_link,
          newElementId: newElementId,
        }
      })
  }

  /**
   * @param elementId {string}
   * @param mediaLink {string}
   * @param elementListId {string}
   * @returns {Promise.<T>}
   */
  delete(elementId, mediaLink, elementListId) {
    return this._httpService.authDelete(
      `${this._environment.serverUrlBase}/v1/media/${elementId}`,
      {
        data: {
          media_link: mediaLink,
          element_list_id: elementListId,
        },
      },
    )
  }

  /**
   * @param elementId {string}
   * @param mediaLink {string}
   * @param elementListId {string}
   * @returns {Promise.<T>}
   */
  restore(elementId, mediaLink, elementListId) {
    return this._httpService.authPut(
      `${this._environment.serverUrlBase}/v1/media/${elementId}/restore`,
      {
        media_link: mediaLink,
        element_list_id: elementListId,
      },
    )
  }

  /**
   * @param elementId {string}
   * @param mediaLink {string}
   * @param elementListId {string}
   * @returns {Promise.<string>} mediaLink
   */
  copy(elementId, mediaLink, elementListId) {
    return this._httpService
      .authPost(
        `${this._environment.serverUrlBase}/v1/media/${elementId}/copy`,
        {
          media_link: mediaLink,
          element_list_id: elementListId,
        },
      )
      .then((data) => data.media_link)
  }

  /**
   * @param questionId {string}
   * @param file {Blob}
   * @param intent {string}
   * @param elementListId {string}
   * @param elementListDb {string}
   * @returns {Promise.<string>} mediaLink
   */
  saveQuestionThumbnail(
    questionId,
    file,
    intent,
    elementListId,
    elementListDb,
  ) {
    let formData = new FormData()

    const mimeType = file.type
    const subtype = mimeType.split("/")[1]
    const ext = subtype.toLowerCase().replace("jpeg", "jpg")
    const uuid = crypto.randomUUID()
    const filename = `${uuid.replace(/-/g, "")}.${ext}`

    formData.append("file", file, filename)
    formData.append("intent", intent)
    formData.append("element_list_id", elementListId)
    formData.append("element_list_db", elementListDb)

    return this._httpService
      .authPost(
        `${this._environment.serverUrlBase}/v1/media/save-question-thumbnail/${questionId}`,
        formData,
        {
          headers: {
            "Content-Type": undefined,
          },
          transformRequest: angular.identify,
        },
      )
      .then((data) => data.media_link)
  }
}
